import type { FormConfig } from '#types/config/components/form'

/*
* The collection person details variation is on EMEA country - GLOBAL15-77011:
* name - all countries
* mobile - UK and France
* email - France only
* contact email - For guest user only, except France
* For example in Belgium, we only require the name and that is all we display across all pages,
* whether it's the user or someone else collecting, or the user is guest or logged in.
*/
export default {
  mobilePhone: {
    requiredLocales: [
      'en-gb',
      'fr-fr'
    ]
  },
  email: {
    requiredLocales: ['fr-fr']
  },
  collectionContact: {
    requiredLocales: [
      'da-dk',
      'de-at',
      'de-be',
      'de-ch',
      'de-de',
      'de-lu',
      'en-ch',
      'en-dk',
      'en-gb',
      'en-ie',
      'en-se',
      'es-es',
      'fr-be',
      'fr-ch',
      'fr-lu',
      'it-ch',
      'it-it',
      'nl-be',
      'nl-lu',
      'nl-nl',
      'pl-pl',
      'pt-pt',
      'sv-se'
    ]
  },
  showETA: true,
  freeSameDayPickUp: {
    requiredLocales: [
      'de-at',
      'de-be',
      'de-de',
      'de-lu',
      'en-dk',
      'en-gb',
      'en-se',
      'es-es',
      'fr-be',
      'fr-fr',
      'fr-lu',
      'it-it',
      'nl-be',
      'nl-lu',
      'nl-nl',
    ]
  }
} satisfies FormConfig['collectionPoint']
